import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useRef, useState } from "react";
import { useLayoutEffect } from "../../helpers";
import { ContainerContext } from "../../Context";
import ContentScroll from "../ContentScroll";
import styles from "../../style.module.scss";
import { useStyle } from "../../hooks";
;
export const Modal = ({ onBackground, onClose, renderProps, ...props }) => {
    if (typeof window === 'undefined') {
        return null;
    }
    const { render, dialogStyle, hideCloseButton, className, style, title, children, contentStyle, closeLabel, bottomSheetMaxWidth, draggable } = props;
    const Styles = useStyle(styles, '_modal-');
    const containerContext = useContext(ContainerContext);
    const modalRef = useRef(null);
    const [position, setPosition] = useState({
        x: 0,
        y: 0
    });
    const startPosition = useRef({
        x: 0,
        y: 0
    });
    const endPosition = useRef({
        x: 0,
        y: 0
    });
    const modalSize = useRef({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    const panActive = useRef(false);
    const handleMoveStart = ({ target, ...e }) => {
        if (!target.closest('header') || !draggable || !modalRef.current)
            return;
        const { x, y, width, height } = modalRef.current.getBoundingClientRect();
        const { clientX, clientY } = 'touches' in e ? e.touches[0] : e;
        panActive.current = true;
        startPosition.current = {
            x: clientX,
            y: clientY
        };
        modalSize.current = {
            x,
            y,
            width,
            height
        };
        modalRef.current?.classList.add(styles['drag']);
    };
    const handleMoveEnd = () => {
        if (!panActive.current)
            return;
        panActive.current = false;
        endPosition.current = { ...position };
        modalRef.current?.classList.remove(styles['drag']);
    };
    const handleMove = (e) => {
        if (!panActive.current)
            return;
        e.stopPropagation();
        const { clientX, clientY } = 'touches' in e ? e.touches[0] : e;
        const dx = clientX - startPosition.current.x;
        const dy = clientY - startPosition.current.y;
        const newX = endPosition.current.x + dx;
        const newY = endPosition.current.y + dy;
        const halfW = window.innerWidth / 2;
        const halfH = window.innerHeight / 2;
        const maxX = halfW - modalSize.current.width / 2;
        const maxY = halfH - modalSize.current.height / 2;
        const clampedX = Math.max(Math.min(newX, maxX), -maxX);
        const clampedY = Math.max(Math.min(newY, maxY), -maxY);
        setPosition({ x: clampedX, y: clampedY });
    };
    useLayoutEffect(() => {
        if (!containerContext.footer)
            return;
        containerContext.setFooter('mount');
    }, [containerContext.footer]);
    return (_jsxs("div", { className: Styles('modal-wrapper'), onMouseDown: handleMoveStart, onMouseUp: handleMoveEnd, onMouseLeave: handleMoveEnd, onMouseMove: handleMove, onTouchStart: handleMoveStart, onTouchEnd: handleMoveEnd, onTouchCancel: handleMoveEnd, onTouchMove: handleMove, children: [_jsx("div", { className: Styles('background'), onClick: onBackground }), _jsxs("dialog", { className: Styles('modal-container'), tabIndex: 1, role: "dialog", style: {
                    maxWidth: bottomSheetMaxWidth,
                    transform: `translate(calc(-50% + ${position.x}px), calc(-50% + ${position.y}px))`,
                    ...dialogStyle
                }, ref: modalRef, open: true, children: [(typeof render === 'function' && !hideCloseButton) &&
                        _jsx("div", { className: Styles('close-block'), onClick: onBackground, children: _jsx("div", { className: Styles(['close', 'large']), onClick: onClose }) }), typeof render === 'function' ? render(renderProps) :
                        _jsxs("div", { className: Styles('modal') + (className ? ' ' + className : ''), style: style, children: [_jsxs("header", { className: Styles('header'), children: [_jsx("div", { className: Styles('text'), children: title }), (!hideCloseButton) && (closeLabel ? _jsx("span", { children: closeLabel, onClick: onClose }) : _jsx("span", { className: Styles('close'), onClick: onClose }))] }), _jsx(ContentScroll, { className: Styles('content'), style: contentStyle, active: true, children: children }), containerContext.footer ? _jsx("footer", { className: Styles('footer'), ref: renderProps.footerRef }) : null] })] })] }));
};
